/** @format */

import React, { useState } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import {
  Navigation,
  Home,
  About,
  Modal,
  Sign,
  Suggestions,
  Vacancies,
} from 'screens'

import styles from './unauthorized.module.scss'

export const Unauthorized = () => {
  const [openModal, setOpenModal] = useState(false)
  const handleModal = () => setOpenModal(!openModal)
  return (
    <>
      <Switch>
        <Route exact path="/sign" component={Sign} />
        <Route
          render={() => (
            <>
              <div className={styles.wrapper}>
                <div className={styles.container}>
                  <header className={styles.header}>
                    <Navigation handleModal={handleModal} />
                  </header>

                  <main className={styles.main}>
                    <Switch>
                      <Route exact path="/" component={Home} />
                      <Route path="/about" component={About} />
                      <Route path="/suggestions" component={Suggestions} />
                      <Route path="/vacancies" component={Vacancies} />
                      <Redirect to="/" />
                    </Switch>
                  </main>
                </div>
              </div>
              {openModal && <Modal handleModal={handleModal} />}
            </>
          )}
        />
      </Switch>
    </>
  )
}
